module.exports = __webpack_public_path__ + "img/scene-problemsolver.6dffae1c.svg";